import Config from '../Config';
import {format_without_time} from '../Utils';
import { RestService } from './RestService';

export const JobService = {
    getJobs: async function(startdate, enddate, start = 0, offset = 20){
        return RestService.get(`${Config.get_jobs}startdate=${startdate.format(format_without_time)}&enddate=${enddate.format(format_without_time)}&from=${start}&offset=${offset}`, {})
        .then(response => response.json());
    },
    getJobDetails: async function(job_id){
        return RestService.get(`${Config.get_job_detail}job_id=${job_id}`, {})
        .then(response => response.json());
    },
    triggerB2BScheduler: async function(job_date){
        return RestService.get(`${Config.trigger_b2b_scheduler_url}job_date=${job_date}`, {})
        .then(response => response.json());
    },
}